import { useEffect } from 'react'
import { useSiteState } from 'siteState/shared'
import { FilterFieldsDisplayOptions } from '../types'

export type UseFilterDisplayOptionsParams = {
  elementUuid: string
  hideFilteraction: boolean
  hideMainCollapsibleContainer: boolean
  hideFieldsCollapsibleContainer: boolean
  hideFilterFields?: boolean
}

export type UseFilterDisplayOptionsResult = {
  displayOptions: FilterFieldsDisplayOptions | undefined
}

export const useFilterDisplayOptions = ({
  elementUuid,
  hideFilteraction,
  hideMainCollapsibleContainer,
  hideFieldsCollapsibleContainer,
  hideFilterFields
}: UseFilterDisplayOptionsParams): UseFilterDisplayOptionsResult => {
  const [displayOptions, setDisplayOptions] =
    useSiteState<FilterFieldsDisplayOptions>('filter-display-options')

  useEffect(() => {
    setDisplayOptions((prevState) => ({
      ...prevState,
      [elementUuid]: {
        hideFilteraction,
        hideMainCollapsibleContainer,
        hideFieldsCollapsibleContainer,
        hideFields: !!hideFilterFields
      }
    }))
  }, [
    elementUuid,
    hideFieldsCollapsibleContainer,
    hideFilteraction,
    hideFilterFields,
    hideMainCollapsibleContainer,
    setDisplayOptions
  ])

  return {
    displayOptions
  }
}
